<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card content-crud">
          <div class="ibox-title" style="padding: 16px">
            <h3>Lista de Ausentes</h3>
          </div>
          <div class="row" style="padding: 0px 0px 16px 16px">
            <div class="col-md-3">
              <label>ID</label>
              <input type="text" class="form-control" v-model="filtro.id" />
            </div>
            <div class="col-md-3">
              <label>Nome do Paciente</label>
              <input
                type="text"
                class="form-control"
                v-model="filtro.nome_paciente"
              />
            </div>
            <div class="col-md-3">
              <label>Senha</label>
              <input type="text" class="form-control" v-model="filtro.senha" />
            </div>
            <div class="col-md-3 mt-1">
              <label>Fluxogramas</label>
              <select class="form-control" v-model="filtro.flowchart_id">
                <option value=""></option>
                <option
                  v-for="flowchart in flowcharts"
                  :key="flowchart.id"
                  :value="flowchart.id"
                >
                  {{ flowchart.title }}
                </option>
              </select>
            </div>
            <div class="col-md-3 mt-1">
              <label>Protocolos</label>
              <select class="form-control" v-model="filtro.flowchart_item_id">
                <option value=""></option>
                <option
                  v-for="flowchart_item in flowchart_items"
                  :key="flowchart_item.id"
                  :value="flowchart_item.id"
                >
                  {{ flowchart_item.title }}
                </option>
              </select>
            </div>
            <div class="col-md-3 mt-1">
              <label>Data da Entrada no Setor</label>
              <input
                type="date"
                class="form-control"
                v-model="filtro.created_at"
              />
            </div>
            <div class="row" style="margin-top: 40px">
              <div class="col-md-2">
                <button class="btn btn-primary" @click="getEntity">
                  Filtrar
                </button>
              </div>
            </div>
          </div>
          <div class="ibox-content">
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive-sm">
                  <table
                    role="table"
                    aria-busy="false"
                    aria-colcount="4"
                    class="table b-table"
                  >
                    <thead role="rowgroup" class="">
                      <tr role="row" class="">
                        <th
                          role="columnheader"
                          scope="col"
                          aria-colindex="1"
                          class=""
                        >
                          <div>Episódio</div>
                        </th>
                        <th
                          role="columnheader"
                          scope="col"
                          aria-colindex="1"
                          class=""
                        >
                          <div>Classificação</div>
                        </th>
                        <th
                          role="columnheader"
                          scope="col"
                          aria-colindex="1"
                          class=""
                        >
                          <div>Senha</div>
                        </th>
                        <th
                          role="columnheader"
                          scope="col"
                          aria-colindex="3"
                          class=""
                        >
                          <div>Nome</div>
                        </th>
                        <th
                          role="columnheader"
                          scope="col"
                          aria-colindex="3"
                          class=""
                        >
                          <div>Idade</div>
                        </th>
                        <th
                          role="columnheader"
                          scope="col"
                          aria-colindex="4"
                          class=""
                        >
                          <div>Data/Hora no Setor</div>
                        </th>
                        <th
                          role="columnheader"
                          scope="col"
                          aria-colindex="4"
                          class=""
                        >
                          <div>Observações</div>
                        </th>
                        <th
                          role="columnheader"
                          scope="col"
                          aria-colindex="4"
                          class=""
                        >
                          <div>Fluxograma</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody role="rowgroup">
                      <tr
                        role="row"
                        class=""
                        v-for="atendimento in atendimentos"
                        :key="atendimento.id"
                      >
                        <td aria-colindex="1" role="cell" class="">
                          {{ atendimento.id }}
                        </td>
                        <td aria-colindex="1" role="cell" class="">
                          <div class="row">
                            <div class="col-md-12">
                              <button
                                :class="
                                  classificacaoColor(atendimento.classificacao)
                                "
                              >
                                {{
                                  classificacaoLabel(atendimento.classificacao)
                                }}
                              </button>
                            </div>
                          </div>
                        </td>
                        <td aria-colindex="1" role="cell" class="">
                          {{ atendimento.senha }}
                        </td>
                        <td aria-colindex="2" role="cell" class="">
                          {{
                            !atendimento.paciente.nome_social ||
                            atendimento.paciente.nome_social === "Não informado"
                              ? atendimento.paciente.nome_paciente
                              : atendimento.paciente.nome_social
                          }}
                          <span
                            class="badge badge-warning"
                            v-if="atendimento.flag_reclassificacao"
                            >RECLASSIFICAÇÃO</span
                          >
                        </td>
                        <td aria-colindex="3" role="cell" class="">
                          {{ diffIdade(atendimento.paciente.data_nascimento) }}
                        </td>
                        <td aria-colindex="4" role="cell" class="">
                          {{ atendimento.created_at_f }}
                        </td>
                        <td aria-colindex="4" role="cell" class="">
                          {{ atendimento.observacao || "-" }}
                        </td>
                        <td aria-colindex="4" role="cell" class="">
                          {{
                            atendimento.flowchart
                              ? atendimento.flowchart.title
                              : "Não possui fluxograma"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colspan="10"
                          class="centered mt-2"
                          v-if="atendimentos.length == 0"
                        >
                          Nenhum paciente ausente encontrado.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div
                class="col-md-6 mt-1 mx-auto d-flex justify-content-center align-items-center"
              >
                <pagination
                  :records="total"
                  :options="options"
                  :per-page="15"
                  @paginate="getEntity"
                ></pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "vue-pagination-2";
export default {
  data() {
    return {
      atendimentos: [],
      flowcharts: [],
      flowchart_items: [],
      filtro: {},
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      total: 0,
      page: 1,
    };
  },
  components: { Pagination },
  methods: {
    classificacaoLabel(classificacao) {
      if (classificacao == 1) {
        return "Vermelho";
      }
      if (classificacao == 2) {
        return "Laranja";
      }
      if (classificacao == 3) {
        return "Amarelo";
      }
      if (classificacao == 4) {
        return "Verde";
      }
      if (classificacao == 5) {
        return "Azul";
      }
      if (classificacao == 6) {
        return "Branco";
      }
      if (classificacao == 998) {
        return "Ausente";
      }
      if (!classificacao) {
        return "Não Classificado";
      }
    },
    classificacaoColor(classificacao) {
      if (classificacao == 1) {
        return "btn-classificacao vermelho";
      }
      if (classificacao == 2) {
        return "btn-classificacao laranja";
      }
      if (classificacao == 3) {
        return "btn-classificacao amarelo";
      }
      if (classificacao == 4) {
        return "btn-classificacao verde";
      }
      if (classificacao == 5) {
        return "btn-classificacao azul";
      }
      if (classificacao == 6) {
        return "btn-classificacao branco";
      }
      if (classificacao == 998) {
        return "btn-classificacao vermelho";
      }
      if (!classificacao) {
        return "btn-classificacao cinza";
      }
    },
    diffIdade(data_nascimento) {
      const self = this;

      var a = moment();
      var b = moment(data_nascimento);

      var years = a.diff(b, "year");
      b.add(years, "years");

      var months = a.diff(b, "months");
      b.add(months, "months");

      var days = a.diff(b, "days");

      if (years < 100) {
        return years + " anos, " + months + " meses, " + days + " dias";
      }
    },
    getEntity: function (page) {
      const self = this;

      self.page = page;

      let api =
        self.$store.state.api +
        "get-atendimentos-ausentes?with[]=flowchart&with[]=flowchart_item&with[]=user&with[]=paciente&page=" +
        self.page;

      self.$loading(true);

      axios
        .post(api, self.filtro)
        .then((response) => {
          self.atendimentos = response.data.data;
          self.total = response.data.total;
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },
    getFlowcharts: function () {
      const self = this;
      let api = self.$store.state.api + "flowcharts?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          self.flowcharts = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getFlowchartItems: function () {
      const self = this;
      let api =
        self.$store.state.api + "flowchart_items?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          self.flowchart_items = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    search: _.debounce(function (e) {
      this.getEntity();
    }, 800),
    filtered_de(date) {
      this.created_at = date;
    },
  },
  mounted() {
    const self = this;

    self.getEntity();
    self.getFlowcharts();
    self.getFlowchartItems();
  },
  created() {},
};
</script>

<style>
.btn-classificacao {
  border-radius: 20px;
  font-size: 12px;
  padding: 5px 15px;
  font-weight: bold;
  text-transform: uppercase;
  border: none;
  color: white;
}

.vermelho {
  background-color: #dc3545;
}

.laranja {
  background-color: #fd7e14;
}

.amarelo {
  background-color: #ffc107;
  color: black;
}

.verde {
  background-color: #28a745;
}

.azul {
  background-color: #007bff;
}

.branco {
  background-color: #6c757d;
}

.cinza {
  background-color: #6c757d;
}

.badge-ausente {
  background-color: #dc3545;
  color: white;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
